import $ from 'jquery';
import { create as createSelectize } from './field--selectize';
import { formatValue } from './field';
import { getSupplierFromAddress } from './registration';

const elementSelector = '[data-plugin="search-supplier"]';

export const create = ($el) => {
    const options = {
        valueField: 'ID',
        labelField: 'Name',
        searchField: 'Name',
        create: false,
        render: {
            option: function(item, escape) {
                return `
                    <div class="field-selectize__item">
                        <div class="field-selectize__title">${escape(
                            item.Name
                        )}</div>        
                    </div>    
                `;
            },
        },
        load: function(query, callback) {
            if (!query.length) return callback();

            callback(getSupplierFromAddress());

            // const url = $el.data('request-action');
            //
            // $.ajax({
            //     url: url + '?q=' + encodeURIComponent(query),
            //     type: 'GET',
            //     error: function() {
            //         callback();
            //     },
            //     success: function(res) {
            //         callback(res.items.slice(0, 10));
            //     }
            // });
        },
        onInitialize: function() {
            // $el.addClass('field__input');
            // formatValue($el);
        },
    };

    createSelectize($el, options);
};

export const createSupplierFields = ($el) => {
    const $fields = $el.find(elementSelector);

    if ($fields.length) {
        $fields.each(function() {
            create($(this));
        });
    }
};

export const binds = () => {
    createSupplierFields($('body'));
};
